import script from "./MaterialTargetTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./MaterialTargetTable.vue?vue&type=script&setup=true&lang=ts"

import "./MaterialTargetTable.vue?vue&type=style&index=0&id=3e10c698&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e10c698"]])

export default __exports__